import api from '../api/client'

/** Descarga autenticada de un PDF/archivo del backend (blob → save as). */
export async function descargarArchivo(url, nombre) {
  const { data } = await api.get(url, { responseType: 'blob' })
  const u = URL.createObjectURL(data)
  const a = document.createElement('a')
  a.href = u
  a.download = nombre
  a.click()
  URL.revokeObjectURL(u)
}

/**
 * Abre un PDF/archivo del backend en otra pestaña, autenticado (blob).
 * NO usar window.open(url) directo — el navegador no manda el bearer
 * token de Sanctum al abrir en otra pestaña → 401/500 sin contexto.
 *
 * Si el server devuelve un blob NO-PDF (HTML de error, JSON de validación),
 * lanza Error con el mensaje extraído — el caller decide cómo mostrarlo.
 * Sin este guard, window.open abre el HTML del 500 como página y el
 * usuario ve "500 Server Error" en la pestaña nueva en vez de un mensaje.
 */
export async function abrirArchivoEnPestana(url) {
  // validateStatus para que NO lance excepción en 4xx/5xx (queremos leer
  // el blob de error para mostrarlo nosotros mismos).
  const { data, status } = await api.get(url, { responseType: 'blob', validateStatus: () => true })
  const tipo = (data?.type || '').toLowerCase()

  if (status >= 400 || (!tipo.includes('pdf') && !tipo.includes('octet-stream'))) {
    // El server devolvió error — intentamos extraer el texto para informar
    let texto = `HTTP ${status}`
    try {
      const t = await data.text()
      // Si es JSON con {message}, mostramos eso; si es HTML, recortamos
      try { const j = JSON.parse(t); texto = j.message || j.error || texto } catch { texto = t.slice(0, 200) }
    } catch { /* dejamos el status */ }
    throw new Error(texto)
  }

  const blob = tipo ? data : new Blob([data], { type: 'application/pdf' })
  const u = URL.createObjectURL(blob)
  window.open(u, '_blank', 'noopener')
  setTimeout(() => URL.revokeObjectURL(u), 60000)
}
